import React from 'react';
import PropTypes from 'prop-types';

import PopularLocations from './PopularLocations';
import LowerContent from './LowerContent';

import './footer.scss';

export function Footer({ year = new Date().getFullYear(), getTollfreePhoneNumber, location }) {
	return (
		<footer className="ph-footer">
			<PopularLocations
			/>
			<LowerContent
				year={year}
				getTollFreePhoneNumber={getTollfreePhoneNumber}
				location={location}
			/>
		</footer>
	);
}

Footer.propTypes = {
	year: PropTypes.number,
	getTollfreePhoneNumber: PropTypes.func,
	location: PropTypes.object
};

export default Footer;
